"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'photo',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      statusObj: {
        0: '未审核',
        1: '审核中',
        2: '审核通过',
        3: '审核不通过'
      },
      tableMaxH: '250',
      list: [],
      listLoading: true,
      listQuery: {
        review_status: '-1',
        type: 1,
        start: 1,
        total: 10,
        page_num: 1
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    /**
     * 请求类型筛选
     * @param {Object} tab
     * @param {Object} event
     */
    typeClick: function typeClick(tab, event) {
      this.listQuery.start = 1;
      this.getList();
    },
    /**
     * 获取数据
     */
    getList: function getList() {
      var _this = this;
      var listQuery = Object.assign({}, this.listQuery, {
          start: this.listQuery.start - 1
        }),
        url = 'agentapi/my_reviewe_ads';
      this.$get(url, listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.list;
        _this.listQuery.page_num = res.page_num;
        if (listQuery.start == 0) _this.tableMaxH = window.innerHeight - _this.$refs.list_table.$el.offsetTop - 80;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    /**
     * 广告审核通过
     */
    auditOk: function auditOk(row) {
      var _this2 = this;
      this.$alert('确定该广告通过审核吗？', '广告审核-通过', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == "confirm") {
            // 【操作埋点】2026-05-25 pc_ad_audit_1 广告审核通过
            _this2.$post('agentapi/review_ad', {
              id: row.id,
              agree: 1
            }, {
              operation_option: '广告审核通过',
              content: "\u901A\u8FC7\u5E7F\u544A\u300C".concat(row.ad_name, "\u300D(ID:").concat(row.id, ")\uFF0C\u4EE3\u7406\u5546\uFF1A").concat(row.name || ''),
              operation_id: 'pc_ad_audit_1'
            }).then(function (res) {
              row.review_status = 2;
              _this2.$message({
                message: '设置成功',
                type: 'success'
              });
            });
          }
        }
      });
    },
    /**
     * 驳回广告
     */
    auditNo: function auditNo(row) {
      var _this3 = this;
      this.$prompt('请填写驳回理由', '广告审核-驳回', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: function beforeClose(action, instance, done) {
          if (action == 'confirm') {
            var value = instance.inputValue;
            if (!value) {
              _this3.$message({
                message: '驳回原因必须填写噢!',
                type: 'warning'
              });
              return;
            }

            // 【操作埋点】2026-05-25 pc_ad_audit_1 广告审核驳回
            _this3.$post('agentapi/review_ad', {
              id: row.id,
              agree: 0,
              refuse_reason: value
            }, {
              operation_option: '广告审核驳回',
              content: "\u9A73\u56DE\u5E7F\u544A\u300C".concat(row.ad_name, "\u300D(ID:").concat(row.id, ")\uFF0C\u4EE3\u7406\u5546\uFF1A").concat(row.name || '', "\uFF0C\u539F\u56E0\uFF1A").concat(value),
              operation_id: 'pc_ad_audit_1'
            }).then(function (res) {
              _this3.$message({
                message: '设置成功',
                type: 'success'
              });
              row.review_status = 3;
              row.refuse_reason = value;
              done();
            });
          } else {
            done();
          }
        }
      });
    }
  }
};